import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";

export default [
    {
        path: "/templates/createSession",
        name: "createSession",
        component: () => import("@/solutionTypes/sessions/_SessionDesignForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: "createtemplate",
            breadcrumbs: {
                icon: "templates-icon",
                paths: [
                    ["/templates", i18n.t("template.title")]
                ]
            },
            title: "template.createNewSessionTemplate"
        },
        props: true
    },
    {
        path: "/templates/:sessionTemplateId/updateSession",
        name: "updateSession",
        component: () => import("@/solutionTypes/sessions/_SessionDesignForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: "updatetemplate",
            breadcrumbs: {
                icon: "templates-icon",
                paths: [
                    ["/templates", i18n.t("template.title")]
                ]
            }
        },
        props: true
    }
];
